export let config = {
  lang: "",
  subDomain: "",
};

const url = window.location.host;
if (url.indexOf("astronow") >= 0) {
  config.lang = "gr";
}
if (url.indexOf("ee") >= 0) {
  config.lang = "ee";
} else if (url.indexOf("es") >= 0) {
  config.lang = "es";
} else if (url.indexOf("fr") >= 0) {
  config.lang = "fr";
} else if (url.indexOf("gr") >= 0) {
  config.lang = "gr";
} else if (url.indexOf("eg") >= 0) {
  config.lang = "eg";
} else if (url.indexOf("nl") >= 0) {
  config.lang = "nl";
} else if (url.indexOf("rs") >= 0) {
  config.lang = "cy";
} else if (url.indexOf("ro") >= 0) {
  config.lang = "ro";
} else if (url.indexOf("gr-mobimilia") >= 0) {
  config.lang = "gr";
} else if (url.indexOf("plus") >= 0) {
  config.lang = "en";
}
config.subDomain = JSON.parse(sessionStorage.getItem("countryCode"))
  ? JSON.parse(sessionStorage.getItem("countryCode")).countryCode
  : "";



// WEBPACK FOOTER //
// ./src/utils/domain_config.js